import React from "react";
import { observer } from "mobx-react";

import { EventOffer } from "@gp/offer";
import { useTranslation } from "react-i18next";
import { Tooltip } from "react-tooltip";

export const LiveEventAggregatedScoreSummary = observer(
	function LiveEventAggregatedScoreSummary({ event }: { event: EventOffer }) {
		const { t } = useTranslation();

		if (!event.result?.aggregateScore) {
			return null;
		}

		const tooltipId = `aggregate-live-${event.id}`;

		let tooltipMessage = "";

		if (event.isLive) {
			tooltipMessage = t("OFFER.TOOLTIP.AGGREGATE_SCORE.LIVE");
		} else {
			tooltipMessage = t("OFFER.TOOLTIP.AGGREGATE_SCORE.PREMATCH");
		}

		return (
			<div
				className="event__aggregate event__aggregate--live"
				data-tooltip-id={tooltipId}
				data-tooltip-content={tooltipMessage}
				data-tooltip-position-strategy="fixed"
			>
				<div className="event__aggregate__item">
					({event.result.aggregateScore.home || 0})
				</div>
				<span className="event__aggregate__middle">-</span>
				<div className="event__aggregate__item">
					({event.result.aggregateScore.away || 0})
				</div>

				<Tooltip
					id={tooltipId}
					className="at-tooltipTeams react-tooltip--primary"
					place="bottom"
					closeOnResize={true}
				/>
			</div>
		);
	}
);
